<template>
  <el-form>
    <div class="avatarTip">
      <div class="photo">
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
        <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
      </div>
      <div class="upload-tips">
        <el-upload
        action=""
        class="mb20"
        :show-file-list="false"
        :before-upload="beforeAvatarUpload"
        :http-request="uploadImg"> <el-button type="primary" round >点击上传</el-button> </el-upload>
        <p class="cpl_grayQ" v-if="remarks" v-html="remarks"></p>
        <p class="col_grayQ" v-if="uploadTips" v-html="uploadTips"></p>
      </div>
    </div>
  </el-form>
</template>

<script>
export default {
  name: 'ImageUpload',
  props: {
    // 上传说明
    remarks: {
      type: String,
      dedault: ''
    },
    // 上传支持类型
    fileTypeList: {
      type: Array,
      default: []
    },
    // 上传文件大小限制
    filesize: {
      type: Number,
      default: -1 //不限制
    }
  },
  data() {
    return {
      imageUrl: '',
    }
  },
  computed: {
    uploadTips() {
      let tips = ''
      if (this.fileTypeList.length) {
        tips = tips + `照片支持<span class="col_red">${this.fileTypeList.join('、')}</span>格式；`
      }
      if (this.filesize > -1) {
        tips = tips + `文件最大不超过<span class="col_red">${this.filesize}kb</span>；`
      }
      return tips
    }
  },
  methods: {
    beforeAvatarUpload(file) {

    },
    uploadImg(data){
      let that = this
      let fileData = data.file
      let reader = new FileReader()
      reader.readAsDataURL(fileData)
      reader.onload = function (e) {
        if (e.currentTarget.result) {
          that.imageUrl = e.currentTarget.result
        }
      }
    },
  }
}
</script>

<style lang="less">
.avatarTip {
  display: flex;
  padding-top: 8px;
  vertical-align: top;
  line-height: 1.8;
}

.photo {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  flex-shrink: 0;
  // cursor: pointer;
  // position: relative;
  // overflow: hidden;
  width: 116px;
  height: 152px;
  // width: 100%;
  // height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.upload-tips {
  margin-left: 20px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}
</style>